// Which details a record is still missing, so Records can remind people kindly and VERA can ask for them.
// The important fields are the ones work depends on: dates, statuses and other dropdowns, links to other records,
// amounts, people, contact details and the record's name. Long notes, photos, multi-links and yes/no stay optional.

import type { CrmField, CrmRecord, CrmType } from "./crm";

const OPTIONAL = new Set(["longtext", "photos", "links", "yesno", "url"]);

export const important = (t: CrmType): CrmField[] => t.fields.filter((f) => !f.hidden && !OPTIONAL.has(f.kind));

const empty = (v: unknown) => v === null || v === undefined || (typeof v === "string" && !v.trim()) || (Array.isArray(v) && !v.length);

/** The important fields this record leaves empty. */
export const missing = (t: CrmType, r: CrmRecord): CrmField[] => important(t).filter((f) => empty(r.values[f.id]));

/** How complete a list is, 0–100: filled important fields over all important fields. */
export function completeness(t: CrmType, rows: CrmRecord[]): number {
  const fields = important(t);
  if (!rows.length || !fields.length) return 100;
  const filled = rows.reduce((n, r) => n + fields.filter((f) => !empty(r.values[f.id])).length, 0);
  return Math.round((100 * filled) / (rows.length * fields.length));
}

/** The values already used in a text field of this list, most used first: the dropdown of "occurrences" while typing. */
export function usedValues(rows: CrmRecord[], field: CrmField, max = 30): string[] {
  const n = new Map<string, number>();
  for (const r of rows) {
    const v = r.values[field.id];
    if (typeof v === "string" && v.trim() && v.length <= 80) n.set(v.trim(), (n.get(v.trim()) ?? 0) + 1);
  }
  return [...n.entries()].sort((a, b) => b[1] - a[1]).slice(0, max).map(([v]) => v);
}
